// extracted by mini-css-extract-plugin
export default {"launcher":"LiveQuizLauncher_launcher__tQIzK","summary":"LiveQuizLauncher_summary__sfLAj","startButton":"LiveQuizLauncher_startButton__k4U8k","note":"LiveQuizLauncher_note__Bkizg"};